import { useState } from "react";
import { SKTToggle } from "../components/SKTToggle";
import { getFromQueryString } from "../utils/queryString";
import { AdminNavigation } from "./components/AdminNavigation";
import { css } from "./config";
import { CustomerListView } from "./views/CustomerListView";
import { OrderListView } from "./views/OrderListView";

const AdminContent = ({ children }) => {
  return <div className={css("container")}>{children}</div>;
};

export const AdminView = () => {
  const [route, setRoute] = useState(
    getFromQueryString("route") ?? "Tilausrekisteri"
  );

  return (
    <main>
      <AdminNavigation route={route} setRoute={setRoute} />
      <br />
      <AdminContent>
        <SKTToggle when={route === "Asiakasrekisteri"}>
          <CustomerListView />
        </SKTToggle>
        <SKTToggle when={route === "Tilausrekisteri"}>
          <OrderListView />
        </SKTToggle>
      </AdminContent>
    </main>
  );
};
